import React from "react";
import PageHeadingSection from '../components/PageHeadingSection';
import CaseCard from '../components/cards/CaseCard';
import {fetchClosedCasesPage} from '../util/pages';
import {useSelector} from 'react-redux';
import {makeGetClosedCases,} from '../features/casesSlice';
import {CaseStatuses} from '../constants';
import SeoTags from '../components/SeoTags';
import {usePagination} from '../util/hooks/usePagination';
import {wrapper} from '../store/store';
import {fetchCasesById, fetchCasesByStatus} from '../features/thunks';
import {withUserGetServerSideProps} from '../util/util';
import {useAuth} from '../util/auth';
import orderBy from 'lodash/orderBy';
import {Button} from '../components/ui/button';
import {ImagePosition, ListCta} from '@/components/ListCta';

function ClosedCases(props) {
    const {content = {}} = props;

    return <>
        <SeoTags config={content.seo} />
        <div className="container">
            <div className="mt-8 mb-16">
                <PageHeadingSection
                    backgroundImage={content.heading_background}
                    title={content.heading_title}
                    subtitle={content.heading_subtitle}
                />
                <div className="mt-4">
                    <CasesList />
                </div>

                <div className="my-24">
                    <ListCta
                        className="bg-teal-400"
                        imgSrc={'/media/2023/man.svg'}
                        imgWidth={301}
                        imgHeight={288}
                        items={[
                            {
                                title: 'More to Explore',
                                text: '',
                                image: '',
                                list: [
                                    {text: 'Solving real-life challenges'},
                                    {text: 'Practicing leadership tools'},
                                    {text: 'Leaders from different cultures'},
                                    {text: '1,5-hour sessions'},
                                ]
                            },
                            {
                                title: 'More to Explore',
                                text: '',
                                image: '',
                                list: [
                                    {text: 'Professional executive coaches'},
                                    {text: 'Experienced mentors'},
                                    {text: 'Personal support and guidance'},
                                    {text: 'Preparing for promotion'},
                                ]
                            }
                        ]}
                        imagePosition={ImagePosition.Right}
                    />
                </div>
            </div>
        </div>
    </>;
}

const CasesList = () => {
    const auth = useAuth();
    const hasActiveSubscription = auth?.user?.hasActiveSubscription;
    const cases = useSelector(state => makeGetClosedCases('desc')(state));
    const caseIds = orderBy(cases, [
        it => {
            if (!hasActiveSubscription) {
                return it.public ? 1 : 0;
            }
            return it.created;
        },
        it => it.created
    ], ['desc', 'desc']).map(it => it.id);

    const {
        fetchNextPage,
        itemsLeft,
        hasNextPage
    } = usePagination({
        initialPageSize: 100,
        pageSize: 100,
        statuses: [CaseStatuses.CLOSED],
        category: null,
        orderBy: 'created',
        sortOrder: 'desc'
    });

    return (
        <>
            <div className="grid gap-6 lg:grid-cols-3">
                {caseIds.map(id => <CaseCard key={id} caseId={id} />)}
            </div>
            {hasNextPage ? (
                <div className="flex mt-6 mb-6 items-center">
                    <Button variant="ghost" onClick={() => fetchNextPage()}>
                        Load more cases ({itemsLeft})
                    </Button>
                </div>
            ) : null}
        </>
    )
}

export const getServerSideProps = wrapper.getServerSideProps(withUserGetServerSideProps(async (ctx) => {
    const content = await fetchClosedCasesPage();

    await ctx.store.dispatch(fetchCasesByStatus({
        limit: 9,
        offset: 0,
        orderBy: 'scheduled_to',
        status: 'CLOSED',
        userId: ctx?.user?.id,
        ctx
    }));

    const caseId = ctx.query.caseId;

    if (caseId) {
        await ctx.store.dispatch(fetchCasesById({caseId, ctx}));
    }


    return {props: {content}}
}));

export default ClosedCases;
